export const ADD__WISHLIST_PRODUCT = 'ADD__WISHLIST_PRODUCT';
export const LOAD__WISHLIST_PRODUCTS = 'LOAD__WISHLIST_PRODUCTS';
export const DELETE__WISHLIST_PRODUCT = 'DELETE__WISHLIST_PRODUCT';
